import initialState from 'redux/initialState';
import types from 'redux/actions/actionTypes';
import { actionTypes as customTypes } from 'modules/_shared/redux/resetActions';

import { Operation } from 'types';

type OperationAction = {
  type: string;
  operations?: Operation[];
  operation?: Operation;
  operationId?: string;
};

const resetStateSociety = () => initialState.operations;

const getOperations = (action: OperationAction) => action.operations;

const createOperation = (operations: Operation[], action: OperationAction) => [
  action.operation,
  ...operations,
];

const updateOperation = (operations: Operation[], action: OperationAction) =>
  operations?.map((operation: Operation) =>
    operation._id === action?.operation?._id ? action.operation : operation
  );

const deleteOperation = (operations: Operation[], action: OperationAction) =>
  operations?.filter(
    (operation: Operation) => operation._id !== action.operationId
  );

export default function reducer(
  operations = initialState.operations,
  action: OperationAction
) {
  switch (action.type) {
    case customTypes.RESET_STATE_SOCIETY:
      return resetStateSociety();

    case types.GET_OPERATIONS:
      return getOperations(action);

    case types.CREATE_OPERATION:
      return createOperation(operations, action);

    case types.UPDATE_OPERATION:
      return updateOperation(operations, action);

    case types.DELETE_OPERATION:
      return deleteOperation(operations, action);

    default:
      return operations;
  }
}
